import { useFeatureFlags } from "@/utils/featureFlags/useFeatureFlags";
import Quote from "./Quote";
import QuoteCondensed from "./QuoteCondensed";

const QuoteWrapper = () => {
  const { isQuotesUpliftEnabled } = useFeatureFlags();

  return isQuotesUpliftEnabled() ? <Quote /> : <QuoteCondensed />;
};

export default QuoteWrapper;
